<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Listado Coordinadores Reemplazo",
            items: [
                {
                text: "Usuarios",
                href: "/"
                },
                {
                text: "Coordinadores Reemplazo",
                active: true
                }
            ],
            usuarios:[],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
        };
    },
    computed:{
        rows() {
            return this.usuarios.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.usuarios.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.name.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        redirigir_a_historial(item){
            //console.log(item);
            localStorage.setItem('user_log',item.id);
            window.location.href = "/web/invitado/historial";
        }
    },
    created(){
        axios.get('/api/get_usuarios').then(res=>{
            this.usuarios=res.data.usuarios.filter((us)=>us.cargo=='Coordinador de reemplazo' && us.id!=20);
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">Nº</th>
                                        <th style="width: 30%;">Nombre</th>
                                        <th style="width: 10%;">Rut</th>
                                        <th style="width: 10%;">Sede</th>
                                        <th style="width: 10%;">Correo</th>
                                        <th style="width: 10%;">Cant. Entradas</th>
                                        <th style="width: 20%;">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.rut }}</td>
                                        <td>{{ item.sede }}</td>
                                        <td>{{ item.email }}</td>
                                        <td></td>
                                        <td>
                                            <b-button variant="primary" size="sm" @click="redirigir_a_historial(item)">Historial</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>